<template>
    <tbody class="item-tab relative total-amount">
    <loading  v-if="sellerSelect=== orders._id.seller[0]._id.toString()" :active.sync="loadingShowPay" :is-full-page="fullPage"></loading>
       <tr class="border-b border-gray-200 hover:bg-gray-100">
            <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300"><div class="text-xs leading-5 capitalize rounded-full">
                <div class="font-bold text-gray-700"><span><i class="material-icons pr-1 tiny">contacts</i><span>{{orders._id.seller[0].fullName}}</span></span></div>
                <!-- <div class="font-light text-gray-700"><span><i class="material-icons tiny">email</i><span>{{orders._id.seller[0].email}}</span></span></div> -->
            </div></td>
            <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300 text-center"><div class="text-xs leading-5 capitalize rounded-full text-gray-900">{{orders.count}}</div></td>
            <td class="px-3 text-center py-1 whitespace-no-wrap border-b border-gray-300"><div class="text-xs leading-5 capitalize rounded-full text-gray-900">{{ orders.amount.toFixed(2)}} <sup>{{warehouse.currency}}</sup></div></td>
            <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300"><div class="flex justify-center"><div class="text-black opacity-75 cursor-pointer  hover:text-blue-500"><div @click="getOrdersBySeller(orders._id.seller[0])"><i class="material-icons mx-2"> remove_red_eye</i></div></div><!--<button @click="OpenClosePopPayMethode('open','allOrders',orders._id.seller[0])" class="bg-gray-800 text-xs text-white px-5 py-1 font-semibold rounded uppercase hover:bg-gray-700  relative loading-amount" :class="loadingShowPay?'disabled-loading':''"> Pay All</button>--></div></td>
        </tr>
    </tbody>
</template>
<script>
export default {
    props: {
     item:Object, 
     warehouse:Object, 
     loadingShowPay: Boolean,
     sellerSelect:String,
    },
    data :function () {
    return {
       orders: this.item,
       fullPage: false,
       loading:false,
      }
    },
    async mounted() {
      
    },
    methods:{ 
        OpenClosePopPayMethode:async  function (action,type, order) {
            this.$emit('OpenClosePopPayMethode',action,type, order);
        },
        getOrdersBySeller:async  function (seller) {
            this.$emit('getOrdersBySeller',seller);
        },
       
    }
}
 </script>